<template>
    <component
        :is="icon"
        v-if="typeof icon !== 'string'"
        :class="[$style.icon, ($style as Record<string, string>)[props.name]]"
        role="img"
        :aria-label="altText"
    />
    <img
        v-else
        :src="icon"
        :alt="altText"
        loading="lazy"
        :class="$style.icon"
    />
</template>
<script setup lang="ts">
import { computed, h } from 'vue'

import { type IconNameType, icons } from './index'

const props = defineProps<{
    name: IconNameType
    alt?: string
}>()

type SvgSpriteRuntime = { svgSprite: (id: string) => string }
const svgSpriteRuntime = __webpack_require__ as unknown as SvgSpriteRuntime

const spriteFabric = ({ id, attrs }: { id: string; attrs: Record<string, string> }) => ({
    render() {
        return h('svg', attrs, [h('use', { 'xlink:href': svgSpriteRuntime.svgSprite(id) })])
    },
})

const icon = computed(() => {
    const component = icons[props.name]
    if (typeof component === 'string') {
        return component
    }

    return spriteFabric(component)
})

const altText = computed(() => props.alt || `${props.name} icon`)

export type { IconNameType }
</script>
<style module>
.icon {
    display: inline-block;
}

.apple {
    transform: translate(0, -7%);
}
</style>
